import React, { createContext, useContext } from 'react'
import type { PageTypeResult } from 'src/hooks/usePageType'

interface GlobalContextValue {
  pageData: PageTypeResult
}

const GlobalContext = createContext<GlobalContextValue | undefined>(undefined)

export const GlobalContextProvider = ({
  children,
  pageData,
}: {
  children: React.ReactNode
  pageData: PageTypeResult
}) => {
  return (
    <GlobalContext.Provider
      value={{
        pageData,
      }}
    >
      {children}
    </GlobalContext.Provider>
  )
}

export const useGlobalContext = () => {
  const context = useContext(GlobalContext)

  if (!context) {
    throw new Error(
      'useGlobalContext must be used within GlobalContextProvider'
    )
  }

  return context
}
